import React, { Component } from 'react';
import './assets/css/not-found.css';

export default class NotFound extends Component {

    componentDidMount() {
    }

    render() {
        return ( 
            <div className="main">
                <div className="boletin-resume gray-bg-full-light">
                    <div className="boletin__section">
                        <div className="row boletin-resume__row">
                            <div className="col-sm-12">
                                <div id="notfound">
                                    <div class="notfound">
                                        <div class="notfound-404">
                                            <h1>404</h1>
                                        </div>
                                        <h2>¡Recurso no encontrado!</h2>
                                        <p>El recurso que estás buscando puede haber sido removida o estar temporalmente no disponible. </p>
                                        <div class="notfound-social">
                                            <a href="https://www.facebook.com/promperu"><i class="fa fa-facebook"></i></a>
                                            <a href="https://www.twitter.com/promperu"><i class="fa fa-twitter"></i></a>
                                            <a href="https://www.facebook.com/youtube"><i class="fa fa-youtube"></i></a>
                                            <a href="https://www.linkedin.com/promperu"><i class="fa fa-linkedin"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}